var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../Util";
import { disabledFieldStyle } from "../Field/InputField";
var Select = function (_a) {
    var id = _a.id, displayName = _a.displayName, options = _a.options, defaultValue = _a.defaultValue, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, reactHookForm = _a.reactHookForm;
    return (_jsx("select", __assign({ id: id, name: displayName, className: classNames("block w-full rounded-md py-2 pl-3 pr-10 text-base sm:text-sm", disabledFieldStyle, error
            ? "border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:border-blue-500 focus:outline-none focus:ring-blue-500"), defaultValue: defaultValue, onChange: onChange, disabled: disabled }, reactHookForm, { children: options.map(function (o, index) {
            return _jsx("option", __assign({ value: o.value, disabled: o.disabled || false }, { children: o.label }), index);
        }) })));
};
export default Select;
